import styled from '@emotion/styled'
import { Divider } from '@hhgtech/hhg-components/components'
import { ZINDEX_SSO } from '@hhgtech/hhg-components/constants'
import { getHeadingStyles } from '@hhgtech/hhg-components/mantine'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'
import { rem } from '@mantine/core'

import { VideoList } from 'components/organisms/videoLists'
import {
  assetImagePath,
  assetSvgPath,
  SCROLL_MARIN_TOP,
  Z_INDEX,
} from 'interfaces/constants'

export const StyledArticleContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`
export const StyledArticleRightColumn = styled.div`
  position: absolute;
  top: 0;
  right: 1rem;
  display: none;
  width: var(--author-width);
  height: 100%;
  ${MediaQueries.mbUp} {
    display: flex;
    flex-direction: column;
  }
  .article-desktop-ad-container {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    padding: 2rem 0;
    .article-desktop-ad-wrapper {
      flex: 1;
      padding: 1rem 0;
      .article-desktop-ad {
        position: sticky;
        margin-left: auto;
        margin-right: auto;
        transition: top 200ms ease-in-out;
        --avoid-nav-banner-height: 0px;
        --avoid-nav-sponsor-height: 0px;
        top: calc(
          90px + var(--avoid-nav-banner-height) +
            var(--avoid-nav-sponsor-height)
        );
        &.avoid-nav-banner {
          --avoid-nav-banner-height: 50px;
        }
        &.avoid-nav-sponsor {
          --avoid-nav-sponsor-height: 50px;
        }
      }
    }
  }
`
export const StyledArticle = styled.div`
  width: 100%;
  .anchor-id {
    display: inline;
    margin: 0;
    scroll-margin-top: ${SCROLL_MARIN_TOP}px;
  }
  ${MediaQueries.mbUp} {
    width: calc(100% - var(--author-width) - 3em);
    .article-ad-container {
      &[data-mobile-ad] {
        margin-bottom: -1rem;
      }
      &[data-publift-ad] {
        margin-left: -1rem;
        margin-bottom: 0.5rem;
      }
      .article-mobile-ad {
        display: none;
      }
      &.ad-avoid-bottom {
        top: -150px;
      }
    }
  }
  hr {
    border: solid 0.5px ${theme.colors.neutral100};
  }
  .article-ad-container {
    position: relative;
    z-index: ${Z_INDEX.articleAdContainer};
    text-align: center;
    margin-bottom: 1rem;
    .article-mobile-ad {
      display: flex;
      justify-content: center;
      margin: 1rem auto;
      &.publift-ad {
        margin: 0 auto;
      }
    }
  }
`
export const StyledContentWrapper = styled.div`
  width: 100%;

  .top-ad {
    margin-left: auto;
    margin-right: auto;
    > div {
      margin-bottom: 1rem;
    }
  }
  .tpads-unit {
    display: none;
  }

  > span.end-of-article:empty {
    display: inline-block;
    height: 0 !important;
  }
`

export const StyledArticleBottomContainer = styled.div`
  padding: 0 0 1rem 0;
  background: white;
`
const TableStyle = `
  table {
    display: block;
    width: 100%;
    border-spacing: 0;
    margin-block: 10px;
    // min-width: 375px;
    max-width: 700px;
    overflow-x: auto;
    ::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 100px;
      height: 4px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: ${theme.colors.gray200};
    }
    thead,
    tbody {
      width: 100%;
    }
    th,
    td {
      min-width: 300px;
      width: 100%;
      padding: 13px 12px;
      font-size: 14px;
      line-height: 22px;
      font-style: normal;
      text-align: left;
      ${MediaQueries.mbDown} {
        min-width: 160px;
      }
      p {
        margin-block-start: 1em;
        margin-block-end: 1em;
      }
    }
    th {
      font-weight: 600;
      text-align: center;
    }
    td {
      font-weight: 400;
    }
    &.spine-table-light {
      thead {
        background-color: #f7f9fc;
        th {
          color: #737373;
        }
      }
      tbody {
        td {
          border-bottom: 1px solid #e4e8ec;
        }
      }
    }
    &.spine-table-dark {
      thead {
        background-color: #87909c;
        th {
          color: #ffffff;
        }
      }
      tbody {
        tr:nth-child(2n) {
          background-color: #f7f9fc;
        }
      }
    }
    &.spine-table-blue {
      thead {
        background-color: #45a4ff;
        th {
          color: #ffffff;
        }
      }
      tbody {
        tr {
          background-color: #f7f9fc;
        }
        td {
          background-color: #f0f8ff;
          border-bottom: 1px solid #bcdeff;
        }
      }
    }
    &.spine-table-pros-cons {
      display: inline-table;
      thead {
        th {
          text-align: center;
          color: #ffffff;
          &:nth-child(2n) {
            background-color: #45a4ff;
          }
          &:nth-child(2n + 1) {
            background-color: #bb82e1;
          }
        }
      }
      tbody {
        td {
          &::before {
            content: '•';
            margin-right: 4px;
          }
          &:nth-child(2n) {
            background-color: #e3f2ff;
          }
          &:nth-child(2n + 1) {
            background-color: #f5edff;
          }
        }
      }
    }
  }
`

export const StyledArticleContentWrapperNoAmp = styled(StyledContentWrapper)`
  position: relative;
  line-height: 1.7;
  overflow-wrap: break-word;
  white-space: pre-line;
  ${MediaQueries.mbUp} {
    font-size: 18px;
  }

  > * {
    max-width: 100%;
  }
  &.disclaimer {
    padding-top: 0;
    padding-bottom: 0;
  }
  sup {
    position: relative;
    bottom: 0.7em;
    font-size: 0.7em !important;
    line-height: 0 !important;
    vertical-align: baseline;
  }

  input {
    background: white;
  }

  img {
    display: block;
    width: 100%;
    height: auto;
    max-width: 100%;
    ${MediaQueries.mbDown} {
      width: calc(100% + 2rem);
      margin-right: -1rem;
      margin-left: -1rem;
      max-width: unset;
    }
  }

  figure {
    figcaption.wp-caption-text {
      margin-top: ${rem(8)};
      margin-bottom: ${rem(24)};
      color: ${theme.colors.gray500};
      font-size: ${rem(14)};
      text-align: center;
    }
  }

  & > {
    p,
    ul,
    form {
      &:not(:last-child) {
        margin-block: 16px;
      }
    }
    ${getHeadingStyles()}
    ${MediaQueries.mbDown} {
      ${getHeadingStyles({ mbDown: true })}
    }

    h2,
    h3,
    h4,
    h5 {
      margin-block: 16px;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      > * {
        font-size: inherit;
        font-weight: inherit;
      }
    }

    div.article-image-alt {
      margin-top: -1.5em;
      margin-bottom: 2em;
      color: ${theme.colors.gray500};
      font-size: 0.8em;
      text-align: center;
    }

    form {
      display: flex;
      align-items: center;
    }

    /* Colors */

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      color: ${theme.colors.gray800};
    }
  }

  ul {
    padding-left: 1rem;
    /* margin-bottom: 1em; */
    margin-block: 16px;

    list-style: inside;
    white-space: normal;
  }

  li {
    position: relative;
    padding-left: 2em;
    margin-bottom: 0.4em;
    list-style-type: none;
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      margin-left: 0.5em;
      color: ${theme.colors.primaryBase};
      content: '•';
      font-size: 1em;
    }
    ul {
      margin-top: 0.5em;
    }
  }

  ol {
    margin-bottom: 1em;
    list-style: decimal;
    li {
      padding-left: unset;
      margin-left: 2em;
      list-style-type: unset;
      &:before {
        display: none;
      }
      &::marker {
        font-size: 1.1em;
        font-weight: bold;
      }
    }
  }

  a {
    color: ${theme.colors.primaryBase};
    text-decoration: none;
  }

  /* Scroll offset */
  h2[id],
  h3[id] {
    scroll-margin: 70px;
  }
  .teads-player {
    position: relative;
    &::before {
      content: '';
      font-size: 10px;
      line-height: 12px;
      color: rgb(140, 140, 140);
      font-weight: 400;
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      padding: 3px 0;
      width: 100%;
      text-align: center;
      z-index: ${ZINDEX_SSO - 9e6};
      background: rgb(248, 249, 252);
    }
  }
  &[data-locale='vi-VN'] {
    .teads-player {
      &::before {
        content: 'Quảng cáo';
      }
    }
  }
  &[data-locale='en-PH'],
  &[data-locale='tl-PH'],
  &[data-locale='my-MM'],
  &[data-locale='hi-IN'],
  &[data-locale='zh-TW'] {
    .teads-player {
      &::before {
        content: 'Advertisement';
      }
    }
  }
  &[data-locale='id-ID'] {
    .teads-player {
      &::before {
        content: 'Iklan';
      }
    }
  }
  &[data-locale='ms-MY'] {
    .teads-player {
      &::before {
        content: 'Iklan';
      }
    }
  }
  &[data-locale='th-TH'] {
    .teads-player {
      &::before {
        content: 'โฆษณา';
      }
    }
  }
  &[data-locale='kh-KH'] {
    .teads-player {
      &::before {
        content: 'ផ្សព្វផ្សាយពាណិជ្ជកម្ម';
      }
    }
  }
  a[href*='typeform.com/'],
  [data-url*='typeform.com/'] {
    display: block;
    iframe {
      height: 100%;
    }
  }
  ${TableStyle}
  /* Key take-away */

  iframe {
    aspect-ratio: 16/9;
    min-height: 0;
    width: 100%;
    height: auto;
    max-width: unset;
    ${MediaQueries.mbDown} {
      margin-inline: -16px !important;
      width: calc(100% + 32px) !important;
    }
  }
  & > p {
    margin-block: 24px;
    ${MediaQueries.mbDown} {
      margin-block: 16px;
    }
  }
  .content-key-takeaways {
    padding: 24px;
    margin: 8px 0;
    background-image: url(${assetImagePath}/key-takeaway-desktop.png);
    background-color: ${theme.colors.primary50};
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom;
    border-radius: ${theme.borderRadius};

    .content {
      br:first-of-type {
        display: none;
      }
      > h2 {
        margin-bottom: 0;
        color: #284a75 !important;
      }
    }
    .title {
      margin-bottom: 16px;
      h3 {
        /* m/H2 24-32 Bold */

        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        /* identical to box height, or 133% */

        letter-spacing: -0.8px;

        /* Secondary/Secondary */

        color: #284a75;
        margin: 0;
      }
    }
    .key-takaway-logo-wrapper {
      display: flex;
      flex-direction: row-reverse;
      margin-top: 12px;
      .key-takaway-logo {
        width: auto;
        height: 24px;
      }
    }
    ${MediaQueries.mbDown} {
      background-image: url(${assetImagePath}/key-takeaway-mobile.png);
      padding: 16px;
      ul {
        padding-left: 0;
      }
    }
  }

  /* Quotation */

  .content-quotation {
    position: relative;
    padding: 36px 0;
    margin: 24px 0;
    ${MediaQueries.mbDown} {
      padding: 40px 0;
    }

    br:first-of-type {
      display: none;
    }

    &::before {
      position: absolute;
      top: 0;
      display: block;
      width: 24px;
      height: 24px;
      content: url(${assetSvgPath}/quote-left-small.svg);
    }
    &::after {
      position: absolute;
      right: 0;
      bottom: 0;
      display: block;

      width: 24px;
      height: 24px;
      content: url(${assetSvgPath}/quote-right-small.svg);
    }

    .title {
      position: absolute;
      bottom: 0;
      left: 32px;
      display: flex;
      align-items: center;
      gap: 8px;
      h3 {
        margin: 0;
        color: ${theme.colors.gray500} !important;
        font-size: 16px !important;
        font-weight: normal;
        line-height: 28px;
      }
      ::before {
        width: 24px;
        height: 24px;

        content: url(${assetSvgPath}/quote-minus.svg);
      }
    }

    .content {
      padding: 0 24px;
      font-size: 18px;
      font-weight: 600;
      line-height: 26px;
    }
  }

  .content-recommendation {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px;
    /* Yellow/Yellow-50 */

    background: #fff8e2;
    /* Yellow/Yellow-800 */

    border-bottom: 2px solid #fe921d;
    border-radius: 8px;

    br:first-of-type {
      display: none;
    }

    .title {
      h3 {
        margin: 0;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 28px;
        letter-spacing: -0.2px;

        /* Yellow/Yellow-800 */

        color: #fe921d;
      }
    }

    .content {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 28px;

      letter-spacing: -0.2px;

      /* Gray/Gray-800 */

      color: #262626;

      li {
        position: relative;
        // padding-left: 24px;
        &:before {
          position: absolute;
          top: 0;
          left: 0;
          color: #fe921d;
          content: '•';
          font-size: 24px;
        }
        *:first-of-type {
          display: initial;
        }
      }
    }

    ${MediaQueries.mbDown} {
      padding: 16px;
      h3 {
        font-size: 16px;
        line-height: 24px;
      }
      p,
      span,
      li {
        font-size: 16px;
        line-height: 28px;
      }
    }
  }

  /* Article summary */
  .content-summary {
    padding: 24px;
    margin-block: 16px;
    background: #f7f9fc;
    border-bottom: 2px solid #2d87f3;
    border-radius: 8px;
    .title {
      margin-bottom: 12px;
      h3 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 28px;
        /* identical to box height, or 156% */

        letter-spacing: -0.2px;

        /* Primary/Primary */

        color: #2d87f3;
        margin: 0;
      }
    }

    .content {
      > p,
      > span,
      h3 {
        margin-bottom: 8px;
      }
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 28px;
      letter-spacing: -0.2px;

      li {
        color: #262626;
        padding-left: 24px;
        &:before {
          position: absolute;
          top: 0;
          left: 0;
          color: ${theme.colors.primaryBase};
          content: '•';
          font-size: 24px;
          margin-left: 0;
        }
        *:first-of-type {
          display: initial;
        }
      }
    }
    ${MediaQueries.mbDown} {
      padding: 16px;
      ul {
        padding-left: 0;
      }
      p,
      span {
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        letter-spacing: -0.2px;
      }
      h3 {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`

export const StyledDivider = styled(Divider)`
  ${MediaQueries.mbDown} {
    margin-right: -16px;
    margin-left: -16px;
  }
`
export const StyledEmbedHealtool = styled.div<{ transparentStyle?: boolean }>`
  margin-top: 12px;
  ${MediaQueries.mbDown} {
    margin-right: -16px;
    margin-left: -16px;
  }
`

export const StyledJumpingLink = styled.div`
  margin-bottom: 16px;
  a {
    color: ${theme.colors.secondaryBase};
    font-size: 16px;
    font-weight: ${theme.sizes.fwBold};
    line-height: 28px;
    text-decoration: none;
    position: relative;
    display: inline;
    padding: 4px 0;
  }
  a:after {
    content: url('/svg/divider.svg');
    display: inline;
    padding: 0 8px;
    position: relative;
    top: 3px;
  }
  a:last-child:after {
    content: none;
  }
  &.prefont {
    letter-spacing: -0.2px;
    word-spacing: 0.7px;
  }
`

export const StyledVideoList = styled(VideoList)`
  ${MediaQueries.mbDown} {
    margin-inline: 0;
  }
`

export const StyledArticleContentItemContainer = styled.div`
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  &[data-hidden='true'] {
    height: 0;
    opacity: 0;
    pointer-events: none;
    overflow: hidden;
  }
  .ad-afterimage {
    margin-top: -1rem;
  }
`
